import { ca } from '@cian/analytics';
import { ISpecialPromoSchema } from '../../repositories/newbuilding-card/entities/special_promos/SpecialPromoSchema';

export const trackSpecialPromoLinkClick = (specialPromo: ISpecialPromoSchema | null) => () => {
  const isPik =
    specialPromo && specialPromo.showNewbuildingsLabel && specialPromo.showNewbuildingsLabel.search('ПИК') !== -1;

  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_JK',
    action: 'jk_on_map',
    label: isPik ? 'pik' : 'special_promo',
    useLastProducts: true,
  });
};
